
























import { Component, Vue, Prop } from "vue-property-decorator";
import { customCutTonguePreview, customCutTongueSave } from "@/request/idr";
import CsPic from "./cornerstone-pic.vue";
@Component({
  components: {
    CsPic
  }
})
export default class IdrCustomCut extends Vue {
  @Prop()
  private picSrc: any;
  @Prop()
  private tongue: any;
  @Prop()
  private picType: any;
  private ifPreviewed: boolean = false;
  private previewSrc: any = "";
  /**
   * @description 关闭窗口
   */
  private close() {
    this.$emit("close");
  }
  /**
   * @description 重新分割
   */
  private cancel() {
    if (this.ifPreviewed) {
      this.ifPreviewed = false;
      this.$nextTick().then(() => {
        (this.$refs.picControl as any).fenge();
      });
    } else {
      (this.$refs.picControl as any).clearFenge();
    }
  }
  /**
   * @description 预览
   */
  private confirm() {
    const { points, width, height } = this.getPoints();
    const params: any = {
      tongue_id: this.tongue.tongue_id,
      image_url: this.tongue["舌象照片"]["分割前图片"],
      points,
      width,
      height
    };
    customCutTonguePreview(this, params).then((data: any) => {
      this.previewSrc = data + "?t=" + new Date().getTime();
      this.ifPreviewed = true;
    });
  }
  /**
   * @description 从数据中选出点
   */
  private getPoints() {
    const result = (this.$refs.picControl as any).getFengeData();
    return result;
  }
  /**
   * @description 保存图片
   */
  private save() {
    const params: any = {
      tongue_id: this.tongue.tongue_id,
      image_url: this.previewSrc.split("?")[0]
    };
    console.log(params);
    customCutTongueSave(this, params).then((data: any) => {
      this.$message.success("保存成功");
      this.close();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    (this.$refs.picControl as any).fenge();
  }
}
